import { useMutation } from '@apollo/client';
import React from 'react';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import { gql } from '../../graphql/generated/gql';
import { UIActions } from '../../ui/uiSlice';
import { legacyUpdateQueryList } from '../../utils/graphql/updateQueryList';
import useNavigate from '../../utils/router/useNavigate';
import type { WebhookValues } from './AdminWebhookForm';
import AdminWebhookForm from './AdminWebhookForm';
import { ALL_WEBHOOKS_QUERY } from './AdminWebhooksView';

const CREATE_WEBHOOK_MUTATION = gql(/** @complexity 2 */ `
  mutation createWebhook(
    $enableAllPosts: Boolean
    $events: [WebhookEvent!]!
    $name: String!
    $targetUrl: String!
    $topics: [ID!]
  ) {
    createWebhook(
      enableAllPosts: $enableAllPosts
      events: $events
      name: $name
      targetUrl: $targetUrl
      topics: $topics
    ) {
      id
      name
      targetUrl
      secret
    }
  }
`);

const AdminWebhookNewView = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [createWebhook] = useMutation(CREATE_WEBHOOK_MUTATION);

  const handleSubmit = async (values: WebhookValues) => {
    const { data } = await createWebhook({
      variables: values,
      update: legacyUpdateQueryList(
        { query: ALL_WEBHOOKS_QUERY },
        'session.organization.webhooks',
        'createWebhook',
      ),
    });
    if (data?.createWebhook?.id) {
      navigate(`/admin/developer/webhooks/${data.createWebhook.id}`);
      dispatch(
        UIActions.pushToast({
          level: 'success',
          message: 'Webhook successfully created',
        }),
      );
    }
  };

  return <AdminWebhookForm onSubmit={handleSubmit} />;
};

export default AdminWebhookNewView;
